import * as React from 'react';

export const ConfirmDeleteComponent = () => (
  <div className="row middle-xs center-xs">
    <h2>Are you sure you want to delete this?</h2>
  </div>
);



// WEBPACK FOOTER //
// ./src/common/components/confirm-delete/confirm-delete.tsx